<template>
  <div v-if="info" class="chip-badge" :class="{ 'empty' : info.userKey === null }">
    <v-responsive :aspect-ratio="1" class="chip-badge-inner">
      <v-img contain :aspect-ratio="1" :src="badgeImg" class="img" :class="{ 'no-image' : info.userKey === null }"/>
    </v-responsive>
    <div class="tit" v-if="!hideTitle">{{ info.name }}</div>
  </div>
</template>

<script>
import { mixinAuth } from '@/mixins'
export default {
  name: 'Badge',
  mixins: [mixinAuth],
  props: {
    info: Object,
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    badgeImg () {
      if (this.info && this.info.userKey) {
        return this.getImage(this.info.imgPath)
      } else {
        if (this.isSamsungFire) {
          return this.getImage('badge/ic_no_badge.svg')
        } else {
          return this.getImage(`badge/img-badge-${(Number(this.info.badgeNo) > 9 ? this.info.badgeNo : '00'+this.info.badgeNo )}-off@2x.png`)
          // return this.getImage('badge/ic_no_badge.svg')
        }
      }
    }
  }
}
</script>
